import styled from 'styled-components';

const FieldGroupView = styled.div`
  display: flex;
  margin-bottom: 0.5em;
  > * {
    margin-bottom: 0!important;
    > * {
      margin-bottom: 0!important;
    }
  }
  > *:not(:last-child) {
    margin-right: 0.5em;
    flex: 1;
  }
`;

export default FieldGroupView
